import React from 'react';

const STORAGE_KEY = 'display-settings';
const RECENT_BG_KEY = 'display-settings-recent-bg';

const DEFAULT_SETTINGS = {
  backgroundColor: '#000000',
  backgroundImage: '',
  fontColor: '#ffffff',
  fontSize: 48,
  lineHeight: 1.3,
  autoScroll: false,
  scrollSpeed: 0.6,
};

export function useDisplaySettings() {
  const [settings, setSettings] = React.useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
    } catch (err) {
      console.warn('Failed to load display settings:', err);
    }
    return DEFAULT_SETTINGS;
  });
  const [recentBackgroundImages, setRecentBackgroundImages] = React.useState(() => {
    try {
      const raw = localStorage.getItem(RECENT_BG_KEY);
      if (raw) return JSON.parse(raw);
    } catch (err) {
      console.warn('Failed to load recent backgrounds:', err);
    }
    return [];
  });

  React.useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (err) {
      console.warn('Failed to persist display settings:', err);
    }
  }, [settings]);

  const updateSetting = React.useCallback((key, value) => {
    setSettings((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetSettings = React.useCallback(() => {
    setSettings(DEFAULT_SETTINGS);
  }, []);

  const addRecentBackgroundImage = React.useCallback((value) => {
    const nextValue = String(value || '').trim();
    if (!nextValue) return;
    setRecentBackgroundImages((prev) => {
      const filtered = prev.filter((item) => item !== nextValue);
      const next = [nextValue, ...filtered].slice(0, 8);
      try {
        localStorage.setItem(RECENT_BG_KEY, JSON.stringify(next));
      } catch (err) {
        console.warn('Failed to persist recent backgrounds:', err);
      }
      return next;
    });
  }, []);

  return { settings, updateSetting, resetSettings, recentBackgroundImages, addRecentBackgroundImage };
}

export default useDisplaySettings;
